












































import { Component, Vue, Prop } from "vue-property-decorator";
import { DualNodeContract } from "@foxone/api/src/models/defi";

@Component
class DualNodeListItem extends Vue {
  @Prop() contract!: DualNodeContract;

  get meta() {
    const addSymbol = this.$common.utils.number.addSymbol;
    const getColor = this.$common.utils.helper.getColor;
    const contract = this.contract;
    const { master_asset: asset, name, quantity, last_revenue } = contract;
    let interestRatio = 0;
    if ("interest_ratio" in this.contract) {
      interestRatio = Number(this.contract.interest_ratio);
    }
    const rate =
      +interestRatio === 0
        ? this.$t("common.tbd")
        : this.$common.utils.number.toPercent(interestRatio, true);
    return {
      rate,
      quantity,
      name,
      symbol: asset.symbol.toUpperCase(),
      icon: asset.icon,
      lastRevenue: addSymbol(last_revenue),
      lastRevenueColor: getColor(this.$store, last_revenue),
      rateColor: getColor(this.$store, interestRatio)
    };
  }

  handleToDetail() {
    this.$common.utils.helper.toFusionPath(this, "defi", {
      name: "type-id",
      params: { type: this.contract.type, id: this.contract.scheme_id }
    });
  }
}
export default DualNodeListItem;
